export default __webpack_public_path__ + "static/media/btn-drift-on@3x.f7a61c18.png";